/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Hawking_TitleInputs */

const en_home_quotes_hawking_title = /** @type {(inputs: Home_Quotes_Hawking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theoretical physicist and cosmologist`)
};

/**
* | output |
* | --- |
* | "Theoretical physicist and cosmologist" |
*
* @param {Home_Quotes_Hawking_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_hawking_title = /** @type {((inputs?: Home_Quotes_Hawking_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Hawking_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_hawking_title(inputs)
});